import { useEffect, useState } from 'react';
import BasicInputNumberMask from '../../General/AntComponents/Form/BasicInputNumberMask';
import { stripNonNumeric } from '../../Helpers/Calculations';
import './TextInputStyle.css';

const inputClassName = 'basicinput_de ant-input';
const inputErrorClassName = 'basicinput_de ant-input ant-input-status-error';

//takes an onChange prop and calls it with (dataKey, newValue)
const ZipInput = props => {
    const { def, dataKey, data, onChange, state, warning } = props;
    const [className, setClassName] = useState(inputClassName)

    useEffect(() => {
        checkZip(data);
        
    }, []);

    useEffect(() => {
        if (warning !== "") setClassName(inputErrorClassName);
        else setClassName(inputClassName);
    }, [warning]);

    const getMask = () => {
        if (def.maxLength && def.maxLength === 5)
            return "00000"
        else
            return "00000-0000"
    }

    const getPlaceholder = () => {
        if (def.maxLength && def.maxLength === 5)
            return "#####"
        else
            return "#####-####"
    }

    const checkZip = value => {
        const raw = stripNonNumeric(value);

        if (isNaN(raw) && raw !== "") return;
        if (raw.length > 9) return;
        if (def.maxLength === 5 && raw.length > 5) return;

        var newWarning = "";
        if (raw.length > 0) {
            if (!def.maxLength || def.maxLength === 9) {
                newWarning = (raw.length !== 5 && raw.length !== 9)
                    ? `"${def.label}" must be 5 or 9 digits and a valid zip code`
                    : '';
            }
            else if (def.maxLength && def.maxLength === 5 && raw.length !== 5) {
                newWarning = `"${def.label}" must be 5 digits and a valid zip code`
            }
        }
        onChange(dataKey, raw, newWarning);
    }

    return <span className='ant-input-wrapper'>
        <BasicInputNumberMask
            className={className}
            id={def.dataKey}
            data-input='zipinput_de'
            mask={getMask()}
            readOnly={state.readonly}
            disabled={state.readonly}
            useUnmaskedValue={true}
            onChange={value => checkZip(value)}
            placeholder={getPlaceholder()}
            placeholderChar='#'
            value={data}
        />
    </span>
}

export default ZipInput;
